import { render, staticRenderFns } from "./AssignTicketModal.vue?vue&type=template&id=63045706"
import script from "./AssignTicketModal.vue?vue&type=script&lang=js"
export * from "./AssignTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports